const stripHtml = (value: string) => value.replace(/<[^>]*>/g, '').trim()

const formatMinutesAsHours = (minutes: number | null | undefined): string => {
  if (minutes === null || minutes === undefined) return '-'
  const total = Math.max(0, Math.floor(Number(minutes) || 0))
  const hours = Math.floor(total / 60)
  const mins = total % 60
  if (total === 0) return '0h'
  if (hours === 0) return `${mins}m`
  if (mins === 0) return `${hours}h`
  return `${hours}h ${mins}m`
}

/** Chart display: decimal hours like Figma (`92`, `34.5`). */
const minutesToChartHours = (minutes: number): number => {
  const total = Math.max(0, Number(minutes) || 0)
  return Math.round((total / 60) * 10) / 10
}

const formatChartHours = (minutes: number | null | undefined): string => {
  if (minutes === null || minutes === undefined) return '-'
  const hours = minutesToChartHours(minutes)
  return Number.isInteger(hours) ? String(hours) : hours.toFixed(1)
}

const formatChartHoursLabel = (minutes: number | null | undefined): string =>
  `${formatChartHours(minutes)} h`

const formatUsages = (usages: number): string => {
  const count = Number(usages) || 0
  return count === 1 ? '1 uso' : `${count} usos`
}

const formatPercent = (value: number): string => `${(Number(value) || 0).toFixed(2)}%`

export {
  stripHtml,
  formatMinutesAsHours,
  minutesToChartHours,
  formatChartHours,
  formatChartHoursLabel,
  formatUsages,
  formatPercent,
}
